import Cookies from 'js-cookie';

// Change to true for logging
// ----------------------------------------------------------------
let enableDebugging = false;

// Timeout to ideally ensure that the information is available at
// time of page load. If it isn't the page will reload (below)
// to check for said information.
// ----------------------------------------------------------------
setTimeout(() => {

  // eslint-disable-next-line no-console
  if (enableDebugging === true) { console.log('---------------- BEGIN DEBUGGING ----------------'); }

  // Get all cookies
  // ----------------------------------------------------------------
  let cookies = Cookies.get();

  // Filter cookies by cookie banner's cookie
  // ----------------------------------------------------------------
  let c = Object.keys(cookies).filter(function(k) {
    return k.indexOf('ppms_privacy_') == 0;
  }).reduce(function(keksies, k) {
    keksies[k] = cookies[k];
    return keksies;
  }, {});

  // Filter cookies by cookie banner's pk_id
  // ----------------------------------------------------------------
  let pkId = Object.keys(cookies).filter(function(k) {
    return k.indexOf('_pk_id') == 0;
  }).reduce(function(keksies, k) {
    keksies[k] = cookies[k];
    return keksies;
  }, {});

  // Filter cookies by cookie banner's pk_ses
  // ----------------------------------------------------------------
  let pkSes = Object.keys(cookies).filter(function(k) {
    return k.indexOf('_pk_ses') == 0;
  }).reduce(function(keksies, k) {
    keksies[k] = cookies[k];
    return keksies;
  }, {});

  // Get key of cookie banner
  // ----------------------------------------------------------------
  let getKey = Object.keys(c)[0];
  // eslint-disable-next-line no-console
  if (enableDebugging === true) { console.log('getKey:', getKey); }

  // It's sometimes so that the key isn't available right at page load
  // so do the needful.
  // ----------------------------------------------------------------
  if (!getKey) {
    // eslint-disable-next-line no-console
    if (enableDebugging === true) { console.log('No key detected. Reloading page...'); }
    // This was particularly problematic in Safari (So like all iOS browsers...), so something...
    // reloadPage(1500);
  }

  // Get value of cookie banner's key
  // ----------------------------------------------------------------
  let getValue = Cookies.get(getKey);
  // eslint-disable-next-line no-console
  if (enableDebugging === true) { console.log('getValue:', getValue); }

  let jsonParsed = JSON.parse(getValue);
  let consent = jsonParsed.consents.analytics.status;

  // eslint-disable-next-line no-console
  if (enableDebugging === true) { console.log('jsonParsed.consents.analytics.status:', jsonParsed.consents.analytics.status); }


  // Variable assignment
  // ----------------------------------------------------------------
  // let cookieConsent = Cookies.get('CookieConsent');
  // let cookiesMarketing = 'marketing';
  let embedWrapperCookiesNotAccepted = document.querySelectorAll('.js-embedWrapperCookiesNotAccepted');
  let embedWrapperCookiesAccepted = document.querySelectorAll('.js-embedWrapperCookiesAccepted');
  let cookieChangeConsent = document.querySelectorAll('.js-cookieChangeConsent');

  // Show the embed wrapper acceptance banner if the cookies haven't
  // been set.
  // ----------------------------------------------------------------
  if (
    consent &&
    consent !== 1 &&
    embedWrapperCookiesNotAccepted.length > 0
  ) {
    // eslint-disable-next-line no-console
    if (enableDebugging === true) { console.log('Cookies have NOT been accepted...'); }
    embedWrapperCookiesNotAccepted.forEach((e) => e.style.display = 'block');
  }

  // Check if cookies are accepted and if so then show the video.
  // ----------------------------------------------------------------
  if (
    consent &&
    consent === 1 &&
    embedWrapperCookiesNotAccepted.length > 0
  ) {
    // eslint-disable-next-line no-console
    if (enableDebugging === true) { console.log('Cookies have been accepted...', jsonParsed.consents.analytics.status); }
    embedWrapperCookiesNotAccepted.forEach((e) => e.style.display = 'none');
    embedWrapperCookiesAccepted.forEach((e) => e.style.display = 'block');
  }

  // If user clicks the change consent button within an iframe's
  // replacement content about cookies not being accepted then
  // it's probably easiest to wipe the cookies and reload the page
  // as opposed to trying to finagle directly with cookie banner.
  // Note that this method specifically removes the cookies instead
  // of using cookie banner's own renew/revoke method (which doesn't)
  // seem to exist at the time of creation(?)
  // ----------------------------------------------------------------
  if (
    cookieChangeConsent &&
    embedWrapperCookiesNotAccepted.length > 0
  ) {
    cookieChangeConsent.forEach((e) => e.onclick = function() {
      Cookies.remove(getKey);
      Cookies.remove(pkId);
      Cookies.remove(pkSes);

      reloadPage(250);
    });
  }

  // Reload the page if the consent banners are clicked to kick the
  // YouTube videos into action.
  // ----------------------------------------------------------------
  setTimeout(() => {
    let consentBannerAcceptAllTrigger = document.getElementById('ppms_cm_agree-to-all');
    if (consentBannerAcceptAllTrigger) {
      consentBannerAcceptAllTrigger.onclick = function() {
        reloadPage(250);
      };
    }
  }, 1500);

  // Function to reload page. Gives a small timeout to make sure cookies
  // are set in the browser before reloading. Reload will then ideally
  // validate that cookies are present to show embedded content.
  // ----------------------------------------------------------------
  function reloadPage(delay) {
    setTimeout(() => {
      location.reload();
    }, (delay));
  }

}, 750);

// eslint-disable-next-line no-console
if (enableDebugging === true) { console.log('---------------- END DEBUGGING ----------------'); }



// WEBPACK FOOTER //
// ./js/regular/cookie-banner.js